import React from "react";

import { OnlineLink } from "components";
import { getFullName } from "helpers";
import { getAppStatuses } from "mappers";

import styles from "../search.module.scss";

export const applicationResultItem = (obj): { [key: string]: any } => {
	return (
		<div
			className={`${styles.wrappSearchInfo} flex-wrap`}
			style={{ justifyContent: "flex-start" }}
		>
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>App ID:</p>
					{obj?.number && obj?.id && (
						<p className="mb-0">
							<OnlineLink
								to={`/applications/${obj?.id}`}
								target="_blank"
								style={{ marginLeft: "15px" }}
							>
								{obj.number}
							</OnlineLink>
						</p>
					)}
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>DBA Name:</p>
					<p className={`break-word ${styles.content}`}>
						{obj.merchant_name}
					</p>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Processor / Sponsor:</p>
					<p className={styles.content}>
						{obj.processor} {obj.processor && "/"} {obj.sponsor}
					</p>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Agent Office & Agent:</p>
					<div className={styles.content}>
						{obj?.agent_office && obj?.agent_office_id && (
							<p className="mb-0">
								<OnlineLink
									to={`/system-setup/agent-office-setup/edit-agent-office/${obj.agent_office_id}/general-info`}
									target="_blank"
								>
									{obj.agent_office?.name}
								</OnlineLink>
							</p>
						)}
						{obj.agent_id && obj.agent && (
							<p className="mb-0">
								<OnlineLink
									to={`/system-setup/agent-setup/edit-agent/${obj.agent_id}/general-info`}
									target="_blank"
								>
									{getFullName(obj.agent)}
								</OnlineLink>
							</p>
						)}
					</div>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>App Status:</p>
					<p className={styles.content}>
						{getAppStatuses(obj.application_status)}
					</p>
				</div>
			}
			{
				<div className={styles.searchInfoSection}>
					<p className={styles.labelTitle}>Assigned to:</p>
					<p className={styles.content}>
						{getFullName(obj?.assignee)}
					</p>
				</div>
			}
		</div>
	);
};
